import React from 'react';
import { Modal as BootstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useViewport } from 'utils/getViewport/getViewport';

import './Modal.scss';

const Modal = props => {
  const classes = ['threepp-modal'];
  const { isMobile } = useViewport();
  const { classes: propClasses, onOpened, size, isOpen, toggle, header, children, footer, footerClass, headerClass } = props;
  if (propClasses) {
    classes.push(propClasses);
  }
  return (
    <BootstrapModal
      onOpened={onOpened}
      size={size || 'lg'}
      centered={!isMobile}
      zIndex={1202}
      isOpen={isOpen}
      className={classes.join(' ')}
      toggle={toggle}
      modalClassName="threepp-modal-container"
    >
      {header && (
        <ModalHeader toggle={toggle} className={headerClass || ''}>
          {header}
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
      {footer && <ModalFooter className={`${footerClass || ''}`}>{footer}</ModalFooter>}
    </BootstrapModal>
  );
};

export default Modal;
